import styles from './Icon.module.css';

interface IconProps {
  name: string;
  backgroundColor?: string;
  iconColor?: string;
  size?: number;
}

const ICON_MAP: Record<string, string> = {
  'plus': '+',
  'cart': '🛒',
  'history': '📋',
  'reload': '↻',
  'email': '✉',
  'lock': '🔒',
  'food': '🍽',
  'calendar-month-outline': '📅',
  'account-outline': '👤',
  'chevron-right': '›',
  'arrow-up-bold': '↑',
  'arrow-down-bold': '↓',
  'gift': '🎁',
  'tip': '💰',
  'credit-card': '💳',
  'trophy': '🏆',
  'download': '⬇',
};

export function Icon({
  name,
  backgroundColor = 'var(--toc-blue)',
  iconColor = 'white',
  size = 40,
}: IconProps) {
  const iconChar = ICON_MAP[name] || '?';

  return (
    <div
      className={styles.icon}
      style={{
        backgroundColor,
        color: iconColor,
        width: size,
        height: size,
        fontSize: size * 0.5,
      }}
    >
      {iconChar}
    </div>
  );
}

export default Icon;
